import { useEffect, useState } from "react";
import { useAmn } from "../contexts/AmnContext";
import { EventsListener } from "./EventListener";
// @ts-ignore
import {RetorikAgent} from '@davi/retorik-framework'
import { botEventHandler } from "./BotEventHandler";
import { DispositionHandler } from "./DispositionHandler";
import EnvironmentChoice from "./EnvironmentChoice/EnvironmentChoice";
import useTimer from "../hooks/useTimer";
import { PdfReader } from "./PdfReader";
import { StorageHandler } from "./StorageHandler";

const AmnApp = () =>{
    const Amn = useAmn();
    const [username, setUsername] = useState<string>("");
    useEffect(()=> {
        let _username = localStorage.getItem("username");
        if(_username)
            setUsername(_username)
    }, [])
    const startTimer = (name : string) => {
        Amn.timer.start(name)
    }

    const getTimer = (name : string | undefined = undefined) => {
        if(name){
            console.log(Amn.timer.get(name))
        }
        else{
            console.log(Amn.timer.timers)
        }
            
    }

    const displayPdf = (name : string) => {
        Amn.setPdfToDisplay(name);
        Amn.setShowPDF({show : true, disposition: "full"});
    }
    return (
        
        <>
        <div style={{zIndex:55, position:"absolute", bottom:0}}>
            {username != "" &&
            <>
                <p>Nom d'utilisateur : {username}</p>
                <p>Id de conversation : {Amn.conversationId}</p>
            </>
            }
            {/* 
            <button onClick={() => startTimer("timer1")}>Test</button>
            <button onClick={() => startTimer("timer2")}>Test2</button>
            <button onClick={() => getTimer()}>Get</button>
            <button onClick={() => getTimer("timer1")}>Get</button> 
            <button onClick={() => displayPdf("/pdf/file.pdf")}>PDF</button>
            */}
        </div> 
            <EventsListener/>
            <DispositionHandler/>
            <RetorikAgent 
                config = {Amn.retorikConfig.config}
                chatbotData = {Amn.retorikConfig.chatbotData}
                agentData = {Amn.retorikConfig.agentData}
                addressData={Amn.retorikConfig.addressData}
                userData={Amn.retorikConfig.userData}
                ponyfillFactoryCredentials={Amn.retorikConfig.ponyfillFactoryCredentials}
                externalEventHandler = {botEventHandler}
                customVoice={Amn.retorikConfig.customVoice}
            />
            {Amn.environmentChoice && <EnvironmentChoice />}
            {Amn.pdfToDisplay && <PdfReader file={Amn.pdfToDisplay}/>}
        </>
    )
}

export {
    AmnApp
}
